export default __webpack_public_path__ + "static/media/menu-btn.769ec637.svg";